import { createAction } from "redux-actions";

export const fetchCriteria = createAction("FETCH_CRITERIA");
export const fetchCriteriaInProgress = createAction("FETCH_CRITERIA_INPROGRESS");
export const fetchCriteriaSuccess = createAction("FETCH_CRITERIA_SUCCESS");
export const fetchCriteriaFailure = createAction("FETCH_CRITERIA_FAILURE");